import React from "react";
import { ReactComponent as SendIcon } from "./../../images/send-arrow.svg";
import CheckedIconImg from "./icons/checked-blue.svg";
import {
  Badge,
  BadgeText,
  Form,
  Header,
  Page,
  ReviewCard,
  ReviewsGrid,
  ReviewText,
  StarIcon,
  SubmitButton,
  Text,
  TextArea,
  Wrapper,
} from "./ReviewPage.styles";
import useSetTags from "../../hooks/useSetTags";

const CONFIG = {
  sl: {
    title: "Mnenja in ocene o platformi",
    description:
      "Izvedite vse o eLingu: metoda učenja in prednosti tečajev. Pridružite se eLingu in izkoristite prednosti! Resnični rezultati v kratkem času.",
  },
  sk: {
    title: "Názory a recenzie o platforme",
    description:
      "Tvoje hodnotenie je dôležité - recenzie eLingo nám pomáhajú vyvíjať platformu v súlade s potrebami používateľov.",
  },
  bg: {
    title: "Мнения и отзиви за платформата",
    description:
      "Твоето мнение има значение - отзивите за eLingo ни помагат да развиваме платформата в съответствие с нуждите на потребителите.",
  },
};

const ReviewPage = ({ data }) => {
  useSetTags(CONFIG);

  return (
    <Page>
      <Wrapper hasReviews={!!data.items}>
        <Header>{data.title}</Header>
        <Text>{data.subtitle}</Text>
        <Form action="https://formsubmit.co/support@eou-edu.eu" method="POST">
          <TextArea
            name="content"
            id="content"
            placeholder={data.contentPlaceholder}
          ></TextArea>
          <input
            type="hidden"
            name="_next"
            value={`${window.location.origin}/${data.language}/thankyou`}
          ></input>
          <SubmitButton type="submit">
            {data.submitButton} <SendIcon />
          </SubmitButton>
        </Form>

        {data.items && (
          <ReviewsGrid>
            {data.items.map((item, index) => (
              <ReviewCard
                key={index}
                isLarge={item.isLarge}
                isTall={item.isTall}
              >
                {item.isRecommended && (
                  <Badge>
                    <StarIcon src={CheckedIconImg} alt="Checked" />
                    <BadgeText>{data.recommendedLabel}</BadgeText>
                  </Badge>
                )}
                <ReviewText isDark={item.isLarge}>{item.text}</ReviewText>
              </ReviewCard>
            ))}
          </ReviewsGrid>
        )}
      </Wrapper>
    </Page>
  );
};

export default ReviewPage;
